import { Media } from "reactstrap";
import { ImageProps } from "../../Types/CommonElementType";

const Image: React.FC<ImageProps> = (props) => {
  return <Media {...props} />;
};

export default Image;
